<template>
  <div class="offer-container">
    <div class="offer-head">
      <div style="padding-right: 10px;">
        <p>{{offer.name}} / {{offer.distributed_product.agency.name}}</p>
        <p class="created_at">{{ lead_offer.created_at | moment-date-time}}</p>
      </div>
      <div class="detach-offer-container">
        <button class="btn" @click="detach(offer.id)">Désassocier</button>
      </div>
    </div>
  </div>
</template>
<script>
import {mapActions,mapGetters} from "vuex"

export default {
  name:"Offer",
  props:["lead_offer"],
  computed:{
    ...mapGetters("crm", ["current_lead"]),

    offer() {
      return this.lead_offer.offer
    }
  },
  methods:{
    ...mapActions("crm", ["detach_offer_of_lead", "fetch_a_lead","set_fetching_state"]),
    detach(offer_id)
    {
      this.$emit("detach-offer", {lead_id:this.current_lead.id, offer_id:offer_id})
      // this.set_fetching_state(true)
      // this.detach_offer_of_lead({lead_id:this.current_lead.id, offer_id:offer_id})
      //     .then(() => this.fetch_a_lead(this.current_lead.id))
      //     .then(() => this.set_fetching_state(false))
    }
  },
}
</script>
<style scoped>
.offer-head {
  display: flex;
}

.detach-offer-container {
  margin-left: auto;
}

.created_at {
  color: #999;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// client/components/CRM/Offers/Item.vue